import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { ThemeModeProvider } from './assets/partials/layout/theme-mode/ThemeModeProvider'

ReactDOM.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
